import { Box, FormGroup, Grid, Modal, Typography, styled } from "@mui/material";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import { FontFamily } from "../theme/fontFamily";
import { ThemeColor } from "../theme/color";
import { Formik, Form } from "formik";
import CustomButton from "../button/button";
import { apiErrorMessage } from "../../helper/apiError";
import dayjs from "dayjs";
import * as Yup from "yup";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../select field/OutlinedSelectField";
import {
  AddPaymentDetailsAfterVisaApprovedService,
  CreateDefaultCommissionService,
  UpdateStudentTransactionService,
  calcualteAgentCommissionService,
  getDefaultCommissionDetailsService,
} from "../../Redux/service/Application";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import OnlyDatePicker from "../datepicker/MyDatepicker";
import {
  GetAgentTransactionListAction,
  GetStudentAction,
  GetUnsettledListAction,
} from "../../Redux/action/ApplicationAction";
import Previews from "../dropzone/Mydropzone";
import OutlinedInputField from "../inputfiled/OutlinedInput";
import {
  FieldLabel,
  PayoutModalHeader,
  payoutModalBodySx,
  payoutModalFooterSx,
  payoutModalStyle,
} from "./payoutModal";
import {
  validationCommisionSchema,
  validationDefaultCommisionSchema,
  validationTransactionSchema,
} from "./ValidationConstant";

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const style = payoutModalStyle(640);

export const DefaultCommissionModal = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const formikRef = useRef(null);

  const [DefaultCommission, setDefaultCommission] = useState();

  const getDefaultCommission = async () => {
    await getDefaultCommissionDetailsService().then((res) => {
      if (res.status === 200) {
        setDefaultCommission(res.data.commission);
      }
    }).catch((err) => {
      console.log("err", err)
    })
  };

  useEffect(() => {
    getDefaultCommission();
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={() => onClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <PayoutModalHeader
          title="Update Default Commission Details"
          onClose={() => onClose()}
        />
        <Formik
          innerRef={formikRef}
          initialValues={{
            exchangeRateUSDToINR: DefaultCommission
              ? DefaultCommission?.exchangeRateUSDToINR
              : "",
            gstPercentage: DefaultCommission
              ? DefaultCommission?.gstPercentage
              : "",
            tdsPercentage: DefaultCommission
              ? DefaultCommission?.tdsPercentage
              : "",
          }}
          // validationSchema={validationSchema}
          onSubmit={async (values, { resetForm }) => {
            await CreateDefaultCommissionService(values)
              .then((res) => {
                if (res.status === 200) {
                  dispatch(showSnackbar(res?.data.message, "success"));
                  resetForm();
                  onClose();
                }
              })
              .catch((err) => {
                dispatch(showSnackbar(apiErrorMessage(err), "error"));
              });
          }}
          validationSchema={validationDefaultCommisionSchema}
        >
          {({
            values,
            errors,
            handleBlur,
            handleChange,
            touched,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                minHeight: 0,
              }}
            >
              <Box sx={payoutModalBodySx}>
                <Grid container spacing={2.5}>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <FormGroup style={{}}>
                      <div className="">
                        <FieldLabel>Exchange Rate USD To INR</FieldLabel>
                        <OutlinedInputField
                          value={values.exchangeRateUSDToINR}
                          name={`exchangeRateUSDToINR`}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          placeholder="Enter exchange rate USD To INR"
                          fullWidth={true}
                          helperText={
                            <Typography
                              align="left"
                              // className="px-3"
                              color={ThemeColor.RED}
                              fontSize={fontSize.h4.medium}
                              fontFamily={FontFamily.Lato}
                              fontWeight={fontWeight.W500}
                            >
                              {errors.exchangeRateUSDToINR}
                            </Typography>
                          }
                        />
                      </div>
                    </FormGroup>
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <FormGroup style={{}}>
                      <div className="">
                        <FieldLabel>Gst Percentage</FieldLabel>
                        <OutlinedInputField
                          value={values.gstPercentage}
                          name={`gstPercentage`}
                          onChange={(e) => {
                            // handleInputChange(
                            //   e.target.value,
                            //   transactionId?.agentTransactionId
                            // );
                            handleChange(e);
                          }}
                          placeholder="Enter Gst Percentage"
                          fullWidth={true}
                          helperText={
                            <Typography
                              align="left"
                              // className="px-3"
                              color={ThemeColor.RED}
                              fontSize={fontSize.h4.medium}
                              fontFamily={FontFamily.Lato}
                              fontWeight={fontWeight.W500}
                            >
                              {errors.gstPercentage}
                            </Typography>
                          }
                        />
                      </div>
                    </FormGroup>
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <FormGroup style={{}}>
                      <div className="">
                        <FieldLabel>Tds Percentage</FieldLabel>
                        <OutlinedInputField
                          value={values.tdsPercentage}
                          name={`tdsPercentage`}
                          onChange={(e) => {
                            // handleInputChange(
                            //   e.target.value,
                            //   transactionId?.agentTransactionId
                            // );
                            handleChange(e);
                          }}
                          placeholder="Enter Tds Percentage"
                          fullWidth={true}
                          helperText={
                            <Typography
                              align="left"
                              // className="px-3"
                              color={ThemeColor.RED}
                              fontSize={fontSize.h4.medium}
                              fontFamily={FontFamily.Lato}
                              fontWeight={fontWeight.W500}
                            >
                              {errors.tdsPercentage}
                            </Typography>
                          }
                        />
                      </div>
                    </FormGroup>
                  </Grid>

                </Grid>
              </Box>

              <Box sx={payoutModalFooterSx}>
                <CustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  color={ThemeColor.WHITE}
                >
                  Save Details
                </CustomButton>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};
